import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { BITRIX_STORE } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import type { CatalogDiscoveryResponse } from '@tailorcast/shared-types';

export function useCatalogDiscovery() {
  const { isBitrix24 } = useBitrix24();
  return useQuery({
    queryKey: ['catalogs', 'discover'],
    queryFn: () => api.get<CatalogDiscoveryResponse>(BITRIX_STORE.CATALOGS),
    enabled: isBitrix24,
    staleTime: Infinity,
  });
}
